module.exports = __webpack_public_path__ + "static/media/KMH_5370.2e0219bf.jpg";